import { lazy, Suspense, useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { Styles } from "../styles/styles";

// Manually import each page component instead of dynamically using lazy()
import Home from "../pages/Home";
import noorBot from "../noorBot/noorBot.js";

const PrivacyRedirect = () => {
  useEffect(() => {
    window.location.replace("/privacy.html");
  }, []);

  return (
    <main style={{ padding: "2rem" }}>
      <a href="/privacy.html">Privacy Policy</a>
    </main>
  );
};

const Router = () => {
  return (
    <Suspense fallback={null}>
      <Styles />
      <Header />
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/home" exact component={Home} />
        <Route path="/noorBot" exact component={noorBot} />
        <Route path="/privacy" component={PrivacyRedirect} />
      </Switch>
      <Footer />
    </Suspense>
  );
};

export default Router;
